/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { subscriptionInfoResponseSchema } from "./subscriptionInfoResponseSchema.ts";
import { unauthorizedSchema } from "./unauthorizedSchema.ts";

export const userSubscriptionRetrieveQueryOrgUnitSchema = z
	.uuid()
	.optional()
	.describe("ID точки организации. Если задан — сначала ищется подпискадля этой точки, иначе fallback на подписку организации.");

export const userSubscriptionRetrieveStatus200Schema = subscriptionInfoResponseSchema.describe("Ответ эндпоинта /api/user/subscription.");

export const userSubscriptionRetrieveStatus401Schema = unauthorizedSchema.describe("Сериализатор 401 ошибки - для документации.");

export const userSubscriptionRetrieveResponseSchema = z.union([userSubscriptionRetrieveStatus200Schema, userSubscriptionRetrieveStatus401Schema]);
